"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionMenuLabelEditorSplitContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
// import * as Colors from "../colors";
exports.ActionMenuLabelEditorSplitContainer = styled_components_1.default.div `
  display: flex;

  div {
    flex-grow: 1;
  }
`;
//# sourceMappingURL=action-menu-label-editor-split-container.js.map